import React, { useEffect, useState } from 'react'

import * as S from './styles'
import { TextProps } from '../text'
import { getRandomElement } from '@/utils/randomElement'

export type TypewriterProps = {
  /**
   * Array of texts to be displayed
   *
   * @example
   * ```tsx
   * <Typewriter texts={['Hello', 'World']} />
   * ```
   *
   */
  texts: Array<string>

  /**
   * The size of the text
   *
   * @example
   * ```tsx
   * <Typewriter size="h1" />
   * ```
   *
   * @default 'h1'
   *
   */
  size?: TextProps['size']
}

export const Typewriter: React.FC<TypewriterProps> = ({
  texts,
  size = 'h1',
}) => {
  const [displayText, setDisplayText] = useState('')
  const [word, setWord] = useState('')

  useEffect(() => {
    const getRandomWord = () => {
      const filteredTexts = texts.filter((text) => text !== word)

      if (!filteredTexts.length) return word

      return getRandomElement(filteredTexts)
    }

    let char = 1
    let completedWord = false

    const interval = setInterval(() => {
      if (char > word.length) {
        setTimeout(() => {
          completedWord = true
        }, 500)
      }

      if (completedWord) {
        char -= 1

        if (char < 0) {
          completedWord = false
          char = 1
          setWord(getRandomWord())
          return
        }

        setDisplayText(word.slice(0, char))
        return
      }

      setDisplayText(word.slice(0, char))
      char += 1
    }, 150)

    return () => {
      clearInterval(interval)
    }
  }, [word, texts])

  return (
    <S.TypewriterEffect size={size} color="black">
      {displayText}
    </S.TypewriterEffect>
  )
}
